
/* injects from baggage-loader */

'use strict';

const colorDirectiveModule = angular.module('color.setting', []);

colorDirectiveModule.directive('colorSetting', [
  '$window', '$timeout', '$compile', '$templateCache',
  ($window, $timeout, $compile, $templateCache) => {
    return {
      restrict: 'A',
      scope: {
        data: '=ngModel',
        afterChange: '&'
      },
      templateUrl: settingFolder + '/color/template.jade',
      link: function(scope, element, attrs, ngModel) {

        const listener = scope.$watch('colorValue', (newVal) => {
          if (newVal) {
            scope.data = newVal;
          }
        });

        scope.type = attrs.colorSetting;
        scope.options = {
          opacity: true,
          hide: scope.afterChange
        };
        scope.checkOpacity = () => {
          if (attrs.disableOpacity) {
            $('.minicolors-opacity-slider').hide();
            $('.minicolors-panel-input-opacity').hide();
          } else {
            $('.minicolors-opacity-slider').show();
            $('.minicolors-panel-input-opacity').show();
          }
        };

        const rgba2hex = (rgba) => {
          const rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g);

          if (rgbaStringArray === null) {
            return [rgba, 1];
          } else {
            const rgb = rgbaStringArray[0].split(', ');
            const opacity = rgb[3];
            const hexResult = (rgb && rgb.length === 4) ? '#' + ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) : '';

            return [hexResult, opacity];
          }
        };

        const listener1 = scope.$watch('data', function(newVal, oldVal) {
          if (newVal) {
            $(element).find('.input_color').attr('data-opacity', rgba2hex(newVal)[1]);
            $(element).find('.input_color').removeData('hex');
            $(element).find('[minicolors]').minicolors('value', newVal);
            if (scope.afterChange) {
              scope.afterChange();
            }
          }
        });

        scope.type = attrs.colorSetting;
        scope.$on('$destroy', function() {
          listener();
          listener1();
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/color/color.directive.js